import { Component } from '@angular/core';
import { ResourceService, AlertService } from 'sce-core';

@Component({
  selector: 'lfwms-sql-preview-popup',
  templateUrl: './sql-preview-popup.component.html',
  styleUrls: ['./sql-preview-popup.component.css']
})
export class SqlPreviewPopupComponent {

  query: string;

  constructor(public resourceService: ResourceService,
    private alertService: AlertService) {
  }

  public initialize(query: string) {
    this.query = query;
  }

  /* method used to translate the labels */
  public getLabel(key: any) {
    return this.resourceService.get(key);
  }

  copy(){
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = this.query;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    if (selBox.value) {
      this.alertService.clearAll().success(this.getLabel("sql_query_copied"));
    }
    document.body.removeChild(selBox);
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/sql-preview-popup/sql-preview-popup.component.ts